import * as d3 from 'd3'
export default {
  methods: {

    set_Canvas() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 30).attr('width', 200)
      .attr('opacity', 1).attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)
      })
      .on('click', ()=> {
        if(this.diagramCanvas) {
          d3.select(`#CANVAS_DIAGRAM`).transition().duration(500).attr('opacity', 0)
          d3.select(`#ADDRESS`).transition().duration(500).attr('opacity', 0)
          setTimeout(() => {
            this.diagramCanvas.remove()
            this.sitemapCanvas.remove()
          }, 500) 
        }
      })


      let address = this.canvasForms
      .append('g')
      .attr('id', 'ADDRESS')
      .attr('transform', `translate(${250}, 0)`)
      .attr('opacity', 0)

      address
      .append('text')
      .attr('id', 'TITLE_PHASE')
      .attr('y', 57).attr('fill', '#757575').attr('font-size', 11).attr('opacity', 1)
      .text('Phase')

      address
      .append('text')
      .attr('id', 'TITLE_DIAGRAM')
      .attr('y', 76).attr('fill', '#44A9DF').attr('font-size', 20).attr('opacity', 1)
      .text('Diagram')

      address
      .append('text')
      .attr('id', 'TITLE_DESC')
      .attr('x', this.getNode(`#TITLE_DIAGRAM`)+7).attr('y', 76)
      .attr('fill', '#333').attr('font-size', 12).attr('opacity', 1)
      .text('Description')

      this.canvasForms
      .append('text')
      .attr('x', this.Canvas.CanvasWidth - 40).attr('y', 60).attr('fill', '#44A9DF').attr('font-size', 20).attr('text-anchor', 'end')
      .text(new Date().toISOString().slice(0, 10))

      this.draw_Database() // -----> draw_Database.js

    },


  }
}